import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { AccountIssuer } from './account-issuer.model';
import { Acct } from '../../../../shared/state/accts/acct.model';

export interface AccountIssuersState extends EntityState<AccountIssuer> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'accountIssuers', idKey: 'accountIssuerId' })
export class AccountIssuersStore extends EntityStore<AccountIssuersState> {
    constructor() {
        super();
    }
}

export const transformAccountIssuerToIssuer = (accountIssuer: AccountIssuer) => {
    return {
        name:
            accountIssuer?.accountIssuerLongName || accountIssuer?.accountIssuerShortName,
        displayName: accountIssuer?.accountIssuerShortName,
        type: 'BANK',
        status: accountIssuer?.status,
        id: accountIssuer?.accountIssuerId,
        logoUrl: accountIssuer?.metadata?.logoUrl,
        website: accountIssuer?.metadata?.website
    };
};
